import React from "react";
import * as Accordion from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "../../icons/chevron-down";

const ServicesContent = {
  subHeading: "How do we revolutionize your business?",
  heading:
    "We harness AI-powered intelligence, seamless automation, and cutting-edge software solutions to drive innovation and solve complex AI challenges effortlessly.",
};

const items = [
  {
    id: "item-1",
    title: "AI Solutions",
    descripOne:
      "Step into the future with unityDev's AI-driven solutions. Our cutting-edge AI technologies empower businesses with automation, predictive analytics, and intelligent systems that optimize efficiency and drive innovation.",
    descripTwo:
      "From AI-powered chatbots to machine learning models, explore how we can transform your business with our AI expertise:",
    listItems: [
      "AI Chatbot Development",
      "AI-Powered Workflow Automation",
      "Predictive Analytics & Machine Learning",
      "AI-Based Cybersecurity Solutions",
      "AI Image & Video Processing",
      "AI Natural Language Processing (NLP)",
      "AI-Powered Recommendation Systems",
      "AI Data Extraction & Analysis",
      "Generative AI for Content Creation",
    ],
  },
  {
    id: "item-2",
    title: "Design",
    descripOne:
      "Do you have a SaaS product that requires a deep understanding of the behavior and user experience of your target audience? Have you found the blue ocean and need advice on how to capture early adopters with outstanding Apps? Or do you need a Brand website, not like your neighbor's, made on the knee by a student from a third-world country?",
    descripTwo:
      "There are 2 Billion websites on the Internet, but your target audience only needs one, right? Which one?",
    listItems: [
      "Landing Page",
      "Corporate",
      "Online Store",
      "Portal",
      "I will tell you only after NDA Project",
      "I don't have a clue, but I need some",
    ],
  },
  {
    id: "item-3",
    title: "Website Development",
    descripOne:
      "Step into the Digital Gateway of Your Business where your website is more than a collection of pages; it's the dedicated ambassador for your brand. At unityDev, we craft websites with precision and purpose. Explore how we bring your digital presence to life through our expert services:",
    descripTwo:
      "Experience the unityDev difference as we tailor these services to enhance your brand's online identity with innovation, functionality, and seamless user experiences.",
    listItems: [
      "Custom Website Development",
      "Responsive Web Design",
      "E-commerce Solutions",
      "User Experience (UX) Optimization",
      "Content Management Systems (CMS)",
      "Mobile App Integration",
      "SEO-friendly Web Development",
      "Performance Optimization",
    ],
  },
  {
    id: "item-4",
    title: "Graphic Design",
    descripOne:
      "Today, Appearance Plays a Crucial Role in Business. This isn’t just about creating an attractive image; it’s about fostering the right empathy and establishing a lasting impression in the subconscious of your target audience. We refer to this concept as the 'Voice of the Brand.'",
    descripTwo:
      "So when it comes to Graphic Design, here are a few areas where we can assist you:",
    listItems: [
      "Advertising",
      "Marketing Collateral",
      "Imagery",
      "Photorealistic Content",
      "Print Design",
      "Character Creation",
      "Animation",
    ],
  },
  {
    id: "item-5",
    title: "Staff Augmentation",
    descripOne:
      "Elevate Your Team Beyond the Ordinary with unityDev's Staff Augmentation services. We don't just fill roles; we provide top-tier talent that seamlessly integrates with your existing teams to drive success. Experience the brilliance of our services, including:",
    descripTwo:
      "Let's not just scale; let's innovate and empower your business with the right expertise at the right time.",
    listItems: [
      "On-Demand Talent Acquisition",
      "Seamless Team Integration",
      "Cost-Effective Staffing Solutions",
      "Access to Specialized Expertise",
      "Flexible Hiring Models",
      "Rapid Team Scaling",
      "Dedicated IT Professionals",
      "Project-Specific Talent Deployment",
      "Remote & On-Site Staffing",
      "Continuous Support & Training",
    ],
  },
  {
    id: "item-6",
    title: "CMS Development",
    descripOne:
      "Embark on a Symphonic Journey with unityDev's CMS Development Services, Where we go beyond managing content to create a harmonious blend of user-friendly interfaces and dynamic storytelling. Let us guide you through the crescendo of services we offer:",
    listItems: [
      "Content Management System Excellence",
      "Tailored CMS Solutions for Your Brand",
      "Dynamic Web Content Composition",
      "User-Friendly CMS Interfaces",
      "Innovative Content Organization",
      "Narrative-Infused Web Design",
      "Seamless CMS Integration",
      "Crafted Storytelling Website Development",
      "Strategic Digital Content Management",
      "Unique CMS Customization for Your Brand's Distinctive Voice",
    ],
  },
];

const Services: React.FC = () => {
  const { subHeading, heading } = ServicesContent;
  return (
    <div
      className="py-[2em] sm:py-[3.25em] md:py-[4em] xl:py-[6.25em] story relative border-t border-solid border-[#181823]"
      id="services"
    >
      <div className="w-full mx-auto max-w-[94.25em] px-[1.5em] md:px-[2.5em]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[2em] lg:gap-0">
          <div className="w-full lg:pr-6">
            <h5
              className="text-white text-[1.1em] xl:text-[1.5em] leading-[1.34em]
            mb-[1em] underline font-medium tracking-[0.05em]"
            >
              {subHeading}
            </h5>
            <h2 className="text-white text-2xl md:text-[38px] leading-[1.25em] font-light mb-0">
              {heading}
            </h2>
          </div>
          <div className="w-full lg:max-w-[414px] lg:ml-auto">
            <Accordion.Root
              type="single"
              collapsible
              className="w-full space-y-2"
            >
              {items.map((item) => (
                <Accordion.Item
                  key={item.id}
                  value={item.id}
                  className="w-full !mt-0"
                >
                  <Accordion.Header>
                    <Accordion.Trigger className="flex justify-between items-center w-full py-4 text-blue-gray-700 font-sans text-xl text-left font-semibold leading-snug transition-colors group">
                      <h3
                        className="text-white text-[1em] md:text-2xl
                            leading-[1.4em] border-b-0 font-medium"
                      >
                        {item.title}
                      </h3>
                      <ChevronDownIcon className="h-5 w-5 stroke-white transition-transform duration-200 group-data-[state=open]:rotate-180" />
                    </Accordion.Trigger>
                  </Accordion.Header>
                  <Accordion.Content className="py-[1.25em]">
                    <p className="text-white text-[1.25em] leading-[1.4em] mb-4">
                      {item.descripOne}
                    </p>
                    <p className="text-white text-[1.25em] leading-[1.4em] mb-4">
                      {item.descripTwo}
                    </p>
                    <ul className="list-disc list-inside pl-4">
                      {item.listItems.map((listItem, index) => (
                        <li
                          className="text-white text-[1.25em] leading-[1.4em]"
                          key={index}
                        >
                          {listItem}
                        </li>
                      ))}
                    </ul>
                  </Accordion.Content>
                </Accordion.Item>
              ))}
            </Accordion.Root>
          </div>
        </div>
      </div>
      <div className="absolute top-0 right-0 w-[450px] h-[450px] bg-[#BE261D] blur-[9.375em] rounded-[6.25em] opacity-20 translate-x-[-40%] translate-y-[-70%] pointer-events-none" />
    </div>
  );
};

export default Services;
